import { useState, useEffect } from "react";
import { lookupWord } from "../../utils/words";

export function DictionaryPopup({ word, onClose }) {
  const [entry, setEntry] = useState(null);
  const [loading, setLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    setLoading(true); setNotFound(false); setEntry(null);
    lookupWord(word).then(result => {
      if (result) setEntry(result); else setNotFound(true);
      setLoading(false);
    });
  }, [word]);

  return (
    <div className="dict-overlay" onClick={onClose}>
      <div className="dict-card" onClick={e => e.stopPropagation()}>
        {loading && <div style={{ textAlign: "center", padding: "2rem", color: "var(--muted)" }}>🔍 Looking up <strong>{word}</strong>…</div>}
        {notFound && (
          <div style={{ textAlign: "center", padding: "1rem" }}>
            <div style={{ fontSize: "2rem", marginBottom: ".5rem" }}>📖</div>
            <div style={{ fontWeight: 700, color: "var(--navy)" }}>No definition found</div>
            <div style={{ fontSize: ".85rem", color: "var(--muted)", marginTop: ".35rem" }}>"{word}" wasn't found in the dictionary</div>
          </div>
        )}
        {entry && (
          <>
            <div className="dict-word">{entry.word}</div>
            {entry.phonetic && <div className="dict-phonetic">{entry.phonetic}</div>}
            {entry.results.map((r, i) => (
              <div key={i} className="dict-meaning">
                <div className="dict-pos">{r.partOfSpeech}</div>
                <div className="dict-def">{r.definition}</div>
                {r.example && <div className="dict-ex">"{r.example}"</div>}
              </div>
            ))}
          </>
        )}
        <button className="dict-close" onClick={onClose}>Close</button>
      </div>
    </div>
  );
}
